import React from 'react'

import { HeadingLarge, BodyText, FadeIn, Button } from '@pb/components'

import {
  createStyleboardButtonTrigger,
  myStorybookEmptyHeading,
  myStorybookEmptyText,
} from '../../labels'
import styles from '../../MyStyleboards.scss'
import { NoStyleboardsComponentProps } from '../../types'

const NoStyleboards: React.FC<NoStyleboardsComponentProps> = ({
  createStyleboardModal,
  onClick,
}) => {
  return (
    <FadeIn>
      <div className={styles.emptyContainer}>
        <HeadingLarge Tag="h2" className={styles.emptyHeadline}>
          {myStorybookEmptyHeading}
        </HeadingLarge>

        <BodyText>{myStorybookEmptyText}</BodyText>
        <Button className={styles.emptyCreateTrigger} onClick={onClick}>
          {createStyleboardButtonTrigger}
        </Button>
        {createStyleboardModal}
      </div>
    </FadeIn>
  )
}

export default NoStyleboards
